import { BankAccountSelectField } from '@ovComponents/3-pattern/bankAccountSelectField/bankAccountSelect';
import type { FieldRequiredType } from '@ovComponents/4-module/configurableOptionFields/basicField';
import type { TransferContextData } from '@ovComponents/4-module/workflowCompletion/workflowTypes';
import { showsRequiredFieldError } from '../depositFieldErrors';

type BankAccountOptions = {
  bankAccount?: { required?: FieldRequiredType };
  manualbankAccountLinking?: boolean;
  automatedBankAccountLinking?: boolean;
};

export type DepositEftBankAccountProp = {
  deposit: TransferContextData;
  options: BankAccountOptions;
  queryUserId: string;
  focused: string[];
  onFocus: (field: string) => void;
  onChange: (value: Partial<TransferContextData>) => void;
  showSelectedIcon: boolean;
};

export const DepositEftBankAccount = ({
  deposit,
  options,
  queryUserId,
  focused,
  onFocus,
  onChange,
  showSelectedIcon,
}: DepositEftBankAccountProp) => {
  return (
    <BankAccountSelectField
      key={`bank-account-select-${deposit?.subAccount?.id}`}
      userId={queryUserId}
      sx={{ mb: 2 }}
      disabled={!queryUserId}
      setBankAccount={(e: any) => onChange({ bankAccount: e })}
      bankAccount={deposit?.bankAccount || null}
      accountCurrencies={deposit?.subAccount?.account?.availableCurrencies}
      onBlur={() => onFocus('bankAccount')}
      error={showsRequiredFieldError({
        missing: !deposit?.bankAccount?.id,
        field: 'bankAccount',
        focused,
        requirement: options?.bankAccount?.required,
      })}
      options={options}
      showSelectedIcon={showSelectedIcon}
    />
  );
};
